import React from 'react';
import { bool } from 'prop-types';
import SelectSingleFilterPlain from './SelectSingleFilterPlain';
import SelectSingleFilterPopup from './SelectSingleFilterPopup';

const SelectSingleFilter = props => {
  const { showAsPopup = false, ...rest } = props;
  return showAsPopup ? (
    <SelectSingleFilterPopup {...rest} />
  ) : (
    <SelectSingleFilterPlain {...rest} />
  );
};



SelectSingleFilter.propTypes = {
  showAsPopup: bool,
};

export default SelectSingleFilter;
